module.exports = __webpack_public_path__ + "img/lang_ruby.54acf8ca.svg";